import { apiAuth } from "../api";

export async function updateGuestEmail(guestId, newEmail, bookingId) {
  try {
    const data = await apiAuth("/notifications/guest/email", {
      guestId,
      newEmail,
      bookingId,
    });
    return data;
  } catch (error) {
    console.error("Update guest email failed:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw error;
  }
}
